import React from "react";
import "./CompetitionBrand.css";

export default function CompetitionBrand({ director = false }) {
  return <>
    <span className="apex-mark" aria-hidden="true" style={{ "--apex-artwork": 'url("/branding/apex/brand-board.webp")' }} />
    <span className="apex-brand-copy">
      <span className="apex-brand-name">APEX</span>
      <span className="apex-brand-parent">by RangePocket</span>
      {director && <span className="apex-brand-mode">Director Console</span>}
    </span>
  </>;
}
